import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import EmptyState from "../../components/EmptyState";
import StatusChip from "../../components/StatusChip";
import { api } from "../../lib/api";
import { Send } from "lucide-react";
import { AttachmentsPanel } from "../../design-system/intake/InformationIntake";

export default function NotificationsOutbox() {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(null);
  useEffect(() => { api.get("/notifications/outbox").then(r => setItems(r.data)); }, []);
  return (
    <AppShell
      title="Notifications Outbox"
      subtitle="Every queued email/SMS with its real delivery state. Test recipients are never sent."
    >
      <div className="border border-erf-borderCream bg-erf-cream text-erf-dark rounded-md px-4 py-3 mb-4 text-sm font-nav" data-testid="outbox-truth-banner">
        Provider status (Connected and Verified, or not) is shown on <em>Integrations &amp; API</em>. Each row below shows its own state.
      </div>
      {items.length === 0 ? (
        <EmptyState icon={Send} title="Outbox is empty" subtitle="Notification records are appended here as the system attempts sends." />
      ) : (
        <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
          <table className="w-full erf-table">
            <thead className="bg-erf-creamSecondary">
              <tr>
                <th className="text-left px-3 py-2">Provider</th>
                <th className="text-left px-3 py-2">To</th>
                <th className="text-left px-3 py-2">Subject</th>
                <th className="text-left px-3 py-2">State</th>
                <th className="text-left px-3 py-2 mono">Created</th>
                <th className="text-right px-3 py-2">Attachments</th>
              </tr>
            </thead>
            <tbody>
              {items.map((n) => (
                <React.Fragment key={n.id}>
                  <tr className="border-t border-erf-borderCream/60" data-testid={`outbox-row-${n.id}`}>
                    <td className="px-3 py-2 mono">{n.provider}</td>
                    <td className="px-3 py-2 mono">{n.to}</td>
                    <td className="px-3 py-2 font-nav">{n.subject || "—"}</td>
                    <td className="px-3 py-2"><StatusChip status={n.state || "not_configured"} label={(n.state || "unknown").replace(/_/g, " ")} /></td>
                    <td className="px-3 py-2 mono text-[11px]">{n.created_at}</td>
                    <td className="px-3 py-2 text-right">
                      <button data-testid={`outbox-view-attach-${n.id}`}
                              onClick={() => setExpanded(expanded === n.id ? null : n.id)}
                              className="text-xs underline text-erf-dark/70 hover:text-erf-goldHover">
                        {expanded === n.id ? "Hide" : "View"}
                      </button>
                    </td>
                  </tr>
                  {expanded === n.id && (
                    <tr data-testid={`outbox-attachments-${n.id}`}>
                      <td colSpan={6} className="px-3 py-3 bg-erf-cream/30">
                        <div className="text-[10px] font-mono uppercase text-erf-dark/50 mb-1">
                          Attachments correlated to this notification (read-only viewer, no upload).
                        </div>
                        <AttachmentsPanel recordType="notification" recordId={n.id} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AppShell>
  );
}
